(async () => {
  const code = new URLSearchParams(location.search).get('shop');
  if (!code) return;
  const cart = await fetch('/cart.js').then(r => r.json());
  if (cart.attributes?.popup_shop) { // locked
    console.log("Popup shop: shop already set");
    return;            
  }
  const shop = (window.POPUP_SHOPS || {})[code];
  if (!shop || !shop.active) { // invalid → ignore
    console.log("Popup shop: " + code + " not found or not active");
    return;                                   
  }
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { 
		popup_shop: code,
		popup_shop_number: shop.number,		
		popup_shop_name: shop.name,  
		popup_shop_active: shop.active,
		popup_shop_contact_name: shop.contact_name, 
		popup_shop_contact_phone: shop.contact_phone, 
		popup_shop_company: shop.company, 
		} })
  });
})();